import { useTranslation } from 'react-i18next';
import type { PageType } from 'types';
import type { PopularProductsModule } from 'types/capi/modules';

import ProductCard from '~/components/ProductCard';
import Tracked from '~/components/Tracked';

type Props = { items: PopularProductsModule['items']; pageType: PageType };

function Products({ items, pageType }: Props) {
  return (
    <div className={`grid shrink-0 grid-cols-2 gap-2 md:grid-cols-4 md:gap-6`}>
      {items.map((product, productIndex) => {
        const baseProps = {
          allowNotifications: true,
          cardSize: 'small' as const,
          className: `w-full ${productIndex > 3 ? 'hidden md:flex' : ''}`,
          imageLoading: 'eager' as const,
          overrideInteractionPagePosition: true,
          padImage: true,
          pagePosition: 'Homepage Whats Hot' as const,
          position: productIndex + 1,
          showNotificationCount: true
        };

        return product.type === 'external' ? (
          <ProductCard.External
            key={`product-${productIndex}`}
            product={product}
            pageType={pageType}
            {...baseProps}
          />
        ) : (
          <ProductCard.Internal
            key={`product-${productIndex}`}
            product={product}
            pageType={pageType}
            {...baseProps}
          />
        );
      })}
    </div>
  );
}

function ViewMoreButton() {
  const { t } = useTranslation('common');

  return (
    <div className="w-36">
      <Tracked.InternalLink
        variant="transparent-black-border"
        className="flex items-center justify-center"
        pagePosition="Homepage Whats Hot"
        name="VIEW_MORE"
        to="/release-dates/"
      >
        {t('viewMore')}
      </Tracked.InternalLink>
    </div>
  );
}

export default function PopularProducts({ items, pageType }: Props) {
  const { t } = useTranslation('home');

  return (
    <div className="w-full">
      <div className="flex flex-col items-center justify-center gap-6 px-0 py-10 md:mx-auto md:max-w-6xl md:gap-10 md:py-10">
        <div className="flex flex-col gap-6 self-stretch py-0 pl-4 md:gap-10">
          <div className="flex flex-col gap-2">
            <h2 className="flex flex-col justify-start gap-2 text-left text-[32px] leading-10 md:text-[40px] md:leading-[48px]">
              {t('whatsHot')}
            </h2>
            <div className="text-base md:text-lg">
              {t('whatsHotDescription')}
            </div>
          </div>
          <Products items={items} pageType={pageType} />
        </div>
        <ViewMoreButton />
      </div>
    </div>
  );
}
